import { HttpClient, HttpParameterCodec, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagedResultDto, UpliftRequestSummaryDto, UpliftRequestSummaryQueryDto } from '@app/models/uplift-request-summary.model';
import { catchError, defer, Observable, switchMap } from 'rxjs';
import { Preferences } from '@capacitor/preferences';
import { StorageKey } from '@app/shared/enums';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base/base.service';

// Angular's default codec leaves '+' unencoded, which breaks DateTimeOffset values such as "+08:00".
class StrictHttpParameterCodec implements HttpParameterCodec {
    encodeKey(key: string): string { return encodeURIComponent(key); }
    encodeValue(value: string): string { return encodeURIComponent(value); }
    decodeKey(key: string): string { return decodeURIComponent(key); }
    decodeValue(value: string): string { return decodeURIComponent(value); }
}

@Injectable({
    providedIn: 'root'
})
export class UpliftService extends BaseService {
    readonly BASE_URL = `${environment.gatewayAPI_V1}/Invoices/`;
    //readonly BASE_URL = "http://localhost:5100/api/v1/";

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getUpliftRequestSummary(query: UpliftRequestSummaryQueryDto): Observable<PagedResultDto<UpliftRequestSummaryDto>> {
        const url = `${this.BASE_URL}PurchaseOrder/GetUpliftRequestSummary`;
        return defer(() => Preferences.get({ key: StorageKey[StorageKey.CURRENTPROFILE] })).pipe(
            switchMap(profile => {
                const request: UpliftRequestSummaryQueryDto = {
                    ...query,
                    companyId: profile.value || null,
                    pageNumber: query.pageNumber ?? 1,
                    pageSize: query.pageSize ?? 10
                };
                let params = new HttpParams({ encoder: new StrictHttpParameterCodec() });
                Object.entries(request).forEach(([key, value]) => {
                    if (value !== null && value !== undefined && value !== '') {
                        params = params.set(key, value);
                    }
                });
                return this.httpClient.get<PagedResultDto<UpliftRequestSummaryDto>>(url, { params });
            }),
            catchError(this.handleError)
        );
    }

    public getUpgradeStatuses(): Observable<string[]> {
        const url = `${this.BASE_URL}PurchaseOrder/GetUpgradeStatuses`;

        return this.httpClient.get<string[]>(url).pipe(
            catchError(this.handleError)
        );
    }
}
